import React, { Component } from 'react';
import { NavbarBrand } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

class SidebarNav extends Component {
  render() {
    let navbarBrandProps;
    const { logo } = this.props;

    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: '_blank'
      };
    }

    return (
      <div className="sidenav-header d-flex align-items-center">
        {
          logo ? (
            <NavbarBrand {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
                height="135"
              />
            </NavbarBrand>
          ) : null
        }
        <div className="ml-auto">
          <button
            aria-controls="sidebar-navigation"
            aria-expanded={this.props.sidenavOpen}
            aria-label="Toggle navigation"
            className={classnames("dashboard-layout__desktop-toggle sidenav-toggler d-none d-xl-block active-links", {
              active: this.props.sidenavOpen
            })}
            onClick={ this.props.toggleSidenav }
            type="button"
          >
            <div className="sidenav-toggler-inner active-links">
              <i className="sidenav-toggler-line active-links" />
              <i className="sidenav-toggler-line active-links" />
              <i className="sidenav-toggler-line active-links" />
            </div>
          </button>
          <button aria-label="Close navigation" className="close d-block d-sm-none" type="button" onClick={ this.props.toggleSidenav }>
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
    )
  }
}

SidebarNav.defaultProps = {
  logo: '',
  sidenavOpen: false,
  toggleSidenav: () => {}
};

export { SidebarNav };


